<section class="course-detail" [class.course-detail--parent]="isParentLayout()">
  <div class="course-detail__back">
    @if (isParentLayout()) {
      <app-parent-button variant="text-ghost" (clicked)="goBack()">
        <span class="course-detail__back-icon" aria-hidden="true"></span>
        {{ 'app.components.courseDetail.backToCourses' | translate }}
      </app-parent-button>
    } @else {
      <app-cta-button [variant]="'link'" (clicked)="goBack()">
        <span cta-prefix>
          <img src="/public/svgs/arrow-left.svg" alt="">
        </span>
        <span cta-label>{{ 'app.components.courseDetail.backToCourses' | translate }}</span>
      </app-cta-button>
    }
  </div>

  @if (courseJustCompleted()) {
    <div class="course-completed-banner" role="alert">
      <span class="course-completed-banner__icon" aria-hidden="true">🎓</span>
      <span class="course-completed-banner__text">{{ 'app.components.courseDetail.courseCompleted' | translate }}</span>
    </div>
  }

  <app-course-header
    [title]="course()?.courseName ?? ''"
    [rating]="course()?.averageRating ?? 0"
    [completionPercent]="headerCompletionPercent()"
    [tasksProgress]="tasksProgress()"></app-course-header>

  <div class="course-detail__content">
    <div class="course-detail__main-column">
      <div class="course-hero">
        <div class="course-hero__primary">
          @if (selectedTask(); as task) {
            <app-course-video
              [videoUrl]="videoUrl()"
              [posterUrl]="posterUrl()"
              (videoEnded)="onVideoEnded()"
            />
            @if (selectedTaskQuizPassed()) {
              <div class="quiz-passed" [class.quiz-passed--perfect]="lastQuizResult()?.isPerfect">
                <span class="quiz-passed__icon" aria-hidden="true">{{ lastQuizResult()?.isPerfect ? '🌟' : '✓' }}</span>
                <span class="quiz-passed__text">
                  @if (lastQuizResult(); as r) {
                    {{ r.isPerfect ? ('app.components.quiz.perfectScore' | translate) : ('app.components.quiz.passedWithScore' | translate:{ score: r.correctCount, total: r.total }) }}
                  } @else {
                    {{ 'app.components.quiz.passed' | translate }}
                  }
                </span>
              </div>
            } @else if (selectedTaskWithQuiz()) {
              @if (task.quizes[0].id; as quizId) {
                <app-quiz
                  [description]="task.description || task.title || task.name || ''"
                  [quizId]="quizId"
                  [taskId]="task.id"
                  (quizCompleted)="onQuizCompleted($event)"
                />
              }
            }
          } @else {
            <img
              class="course-hero__primary-image"
              [src]="posterUrl()"
              [alt]="course()?.courseName ?? ''"
            />
          }
          <app-course-tags [tags]="['Top-5']"></app-course-tags>
          <app-course-description [course]="$any(course())"></app-course-description>
        </div>
        <div class="course-hero__structure">
          <app-course-structure
            [course]="course() ?? null"
            [tasks]="tasks()"
            [selectedTaskId]="selectedTask()?.id ?? null"
            [tasksDisabled]="shouldShowJoinButton()"
            (taskClick)="onTaskClick($event)"
          />
        </div>
      </div>
    </div>

    <aside class="course-detail__side-column">
      <app-course-info
        [course]="course() ?? null"
        [showJoinButton]="shouldShowJoinButton()"
        [showCancelButton]="shouldShowCancelButton()"
        [isJoinPending]="isJoinPending()"
        [isLeavePending]="isLeavePending()"
        (joinCourse)="onJoinCourse()"
        (leaveCourse)="onLeaveCourse()"
      ></app-course-info>

      @if (shouldShowCertificate()) {
        <app-course-certificate [course]="course() ?? null"></app-course-certificate>
      }

      <app-course-rating
        [userRating]="course()?.userRating ?? 0"
        [disabled]="!shouldAllowRating()"
        (onRateCourse)="onRateCourse($event)"
      ></app-course-rating>

      <app-course-meta [course]="course() ?? null"></app-course-meta>
    </aside>
  </div>
</section>
